import { render, staticRenderFns } from "./dehorningCow.vue?vue&type=template&id=6fea5c8e&scoped=true&"
import script from "./dehorningCow.vue?vue&type=script&lang=js&"
export * from "./dehorningCow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea5c8e",
  null
  
)

export default component.exports